const enable = true

export const required = v => {
  if (v == null) { return true }
  if (!enable) { return true }

  return !!v || 'Campo Obrigatório'
}

export const max10 = v => {
  if (v == null) { return true }
  if (!enable) { return true }

  return v.length <= 10 || 'Campo deve ter menos de 10 caracters'
}

export const min3 = v => {
  if (v == null) { return true }
  if (!enable) { return true }

  return v.length >= 3 || 'Campo deve ter pelo menos 3 caracters'
}

export const max200 = v => {
  if (v == null) { return true }
  if (!enable) { return true }

  return v.length <= 200 || 'Campo deve ter menos de 200 caracters'
}

export const email = v => {
  if (v == null) { return true }
  if (!enable) { return true }

  if (v.length > 0) {
    return /.+@.+/.test(v) || 'Email inválido'
  }
}
